<template>
  <div id="app" @click="handleUserInteraction">
    <audio ref="audioElement" loop controls style="display: none;">
      <source :src="audioSrc"></source>
    </audio>
    <router-view :key="$route.path"/>
    <modal v-if="tokenClient && showdialog" :msg="msg" :role="tokenClient" @handle-close="handleClose"/>
  </div>
</template>

<script>
import modal from "@/components/modal";
import MixinMqttClient from "@/components/mqtt/MixinMqttClient";

export default {
  name: 'App',
  components: { modal },
  mixins: [MixinMqttClient],
  created() {
  },
  data() {
    return {
      msg: {},
      showdialog: false,
      audioSrc: "",  // 初始为空
      isFirstClick: true  // 标记是否为第一次点击
    }
  },
  computed: {
    tokenClient(){
      return this.mqttUser.tokenClient;
    },
    enableMQTT() {
      return !this.disabledMQTT;
    }
  },
  watch: {
    showdialog(newVal) {
      if (newVal) {
        this.playAudio();
      } else {
        this.stopAudio();
      }
    },
    enableMQTT(newValue){
      if (newValue) {
        this.subscribeTopic()
      } else {
        this.unsubscribeMQTT(this.mqttUserListenerTopicName)
      }
    }
  },
  mounted() {
    this.subscribeTopic()
  },
  destroyed() {
  },
  methods: {
    subscribeTopic() {
      if (this.enableMQTT) {
        this.subscribeMQTT(this.mqttUserListenerTopicName, (message) => {
          this.handleMessage(message);
        });
      }
    },
    handleUserInteraction() {
      if (this.isFirstClick) {
        // 预先调用播放方法以绕过浏览器的限制
        this.$refs.audioElement.play().catch(() => {});
        this.isFirstClick = false; // 更新标记
      }
    },
    playAudio() {
      this.audioSrc = require('@/assets/alert.mp3');
      this.$refs.audioElement.load(); // 重新加载音频
      setTimeout(() => {
        this.$refs.audioElement.play().then(() => {
          console.log('音频播放成功——————————————————————————————————————————————————————————');
        }).catch((error) => {
          console.error('音频播放失败————————————————————————————————————————————————————————', error);
        });
      }, 100); // 延迟100毫秒播放音频
    },
    stopAudio() {
      // 停止音频播放
      if (this.$refs.audioElement) {
        console.log('停止播放音频——————————————————————————————————————————');
        this.$refs.audioElement.pause();
        this.$refs.audioElement.currentTime = 0; // 重置音频时间到开头
      }
    },
    async handleMessage(message) {
      console.log(["App.vue handleMessage", message]);
      if (message) {
        this.msg = JSON.parse(message.toString());
        this.showdialog = true;
      }
    },
    handleClose() {
      this.showdialog = false
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
<style lang="less">
.details-head{
  color: #333333;
  font-size: 20px;
  padding-left: 8px;
  border-left: 3px solid #008DD2;
  text-align: left;
  font-weight: bold;
}
 .interaction-box .el-descriptions{
   flex: 1;
   background: #000;
  }
  .interaction-box .el-descriptions .is-bordered .el-descriptions-item__cell{
    padding: 0 10px;
    height: 62.5px;
    color: #fff;
    background: #133476;
    border: 1px solid #1F60C1;
  }
  .boxs .el-dialog{
    top: 15% !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue